import { useEffect, useRef, useState } from "react";

import styled from "@emotion/styled";
import debounce from "lodash/debounce";

import { breakpoints } from "@/components/layout/Media";

function Masonry({ children, ...htmlProps }) {
  const [columns, setColumns] = useState(1);
  const masonry = useRef(null);
  const bps = Object.values(breakpoints).slice(0, 3);

  function getColumns(width) {
    return bps.reduce((current, bp, i) => {
      return width > bp ? i + 1 : current;
    }, 1);
  }

  useEffect(() => {
    function resizeListener() {
      const c = getColumns(masonry.current.offsetWidth);
      setColumns(c);
    }

    resizeListener();
    const onResize = debounce(resizeListener, 100);

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  function mapChildren() {
    let cols = [];
    for (let i = 0; i < columns; i++) {
      cols.push([]);
    }
    return children.reduce((all, child, i) => {
      all[i % columns].push(child);
      return all;
    }, cols);
  }

  return (
    <div ref={masonry} {...htmlProps}>
      {mapChildren().map((col, ci) => {
        return (
          <div className="column" key={ci}>
            {col.map((child, i) => {
              return <div key={i}>{child}</div>;
            })}
          </div>
        );
      })}
    </div>
  );
}

export default styled(Masonry)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: stretch;
  width: 100%;
  margin: auto;

  .column {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: stretch;
    flex-grow: 1;
  }
`;
